(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["able-react"] = factory();
	else
		root["able-react"] = factory();
})(this, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 1116:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 1217:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export iconVersion */
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1116);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2462);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6942);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8732);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__);


var _excluded = ["className", "developmentUrl", "icon", "screenReaderContent", "size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


var iconVersion = 12;

/**
 * Icons are symbols that provide visual context and communicate function
 * or intent in a universal way.
 *
 * Available icon names are listed at https://confluence.tools.telstra.com/display/DCSYS/Icons
 *
 * @version 1.0.0
 */
function Icon(props) {
  var className = props.className,
    developmentUrl = props.developmentUrl,
    icon = props.icon,
    screenReaderContent = props.screenReaderContent,
    _props$size = props.size,
    size = _props$size === void 0 ? '24' : _props$size,
    other = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1___default()(props, _excluded);
  var href = developmentUrl || "//www.telstra.com.au/content/dam/tcom/able/able-sprites.svg?v".concat(iconVersion);
  var classes = classnames__WEBPACK_IMPORTED_MODULE_2___default()('able-icon', "able-icon--".concat(size), className || null);
  var deprecatedIcons = {
    Visibility: ['ToggleOff, ToggleOn'],
    ScanBarcode: ['Scan']
  };
  var replacementIcons = icon;
  if (deprecatedIcons.hasOwnProperty(icon)) {
    replacementIcons = deprecatedIcons[icon].join(' ');
    console.warn("Icon ".concat(icon, " is deprecated, and will be removed in July 2024. Use '").concat(replacementIcons, "' instead."));
  }
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("svg", _objectSpread(_objectSpread(_objectSpread({
    className: classes,
    role: "img",
    "aria-hidden": !screenReaderContent ? 'true' : 'false'
  }, screenReaderContent && {
    'aria-label': screenReaderContent
  }), {}, {
    focusable: "false"
  }, other), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("use", {
      href: "".concat(href, "#").concat(icon)
    })
  }));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Icon);

/***/ }),

/***/ 2462:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/objectWithoutProperties");

/***/ }),

/***/ 5133:
/***/ (() => {



/***/ }),

/***/ 6168:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1217);
/* harmony import */ var _Icon_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5133);
/* harmony import */ var _Icon_scss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Icon_scss__WEBPACK_IMPORTED_MODULE_0__);



/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_Icon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A);

/***/ }),

/***/ 6942:
/***/ ((module, exports) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 7629:
/***/ (() => {



/***/ }),

/***/ 8732:
/***/ ((module) => {

"use strict";
module.exports = require("react/jsx-runtime");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  AccordionItem: () => (/* reexport */ Accordion_AccordionItem),
  "default": () => (/* binding */ src_Accordion)
});

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var node_modules_classnames = __webpack_require__(6942);
var classnames_default = /*#__PURE__*/__webpack_require__.n(node_modules_classnames);
// EXTERNAL MODULE: external "react/jsx-runtime"
var jsx_runtime_ = __webpack_require__(8732);
;// ./src/Accordion/Accordion.tsx


/**
 * Accordions display a list of high-level options that can expand/contract to reveal more detailed information.
 * The outer Accordion is passed as children one or more AccordionItem.
 *
 * * [View the Accordion pattern documentation on Confluence](https://confluence.tools.telstra.com/display/DCSYS/Accordion)
 * @version 1.0.0
 */
function Accordion(props) {
  var className = props.className,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'Compact' : _props$variant,
    _props$showTopDivider = props.showTopDivider,
    showTopDivider = _props$showTopDivider === void 0 ? false : _props$showTopDivider,
    children = props.children;
  var classes = classnames_default()("able-Accordion--".concat(variant.toLowerCase()), className || undefined, variant === 'Contained' ? 'able-accordion--contained' : undefined,
  // identifier class needed for surface to apply rounded corners
  showTopDivider && variant === 'Contained' ? 'able-Accordion--top-divider-on' : undefined);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("div", {
    className: classes,
    children: children
  });
}
/* harmony default export */ const Accordion_Accordion = (Accordion);
// EXTERNAL MODULE: external "@babel/runtime/helpers/defineProperty"
var defineProperty_ = __webpack_require__(1116);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_);
;// external "@babel/runtime/helpers/slicedToArray"
const slicedToArray_namespaceObject = require("@babel/runtime/helpers/slicedToArray");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray_namespaceObject);
;// external "react"
const external_react_namespaceObject = require("react");
// EXTERNAL MODULE: ./src/Icon/index.ts
var Icon = __webpack_require__(6168);
;// external "lodash-es"
const external_lodash_es_namespaceObject = require("lodash-es");
;// external "@able/web/dist/shared/ts/SheetPresetHeights"
const SheetPresetHeights_namespaceObject = require("@able/web/dist/shared/ts/SheetPresetHeights");
;// ./src/Sheet/Sheet.tsx









var updateAbleSheet = function updateAbleSheet(updateAbleSheetConfig) {
  if (!updateAbleSheetConfig || updateAbleSheetConfig.moveFocusIntoSheet) {
    window.dispatchEvent(new CustomEvent('focusMovedIntoSheet'));
  }
  window.dispatchEvent(new CustomEvent('reIndexSheetModalKeyboardTrap'));
};
var Sheet = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, ref) {
  var _ref$backButtonScreen = _ref.backButtonScreenReaderContent,
    backButtonScreenReaderContent = _ref$backButtonScreen === void 0 ? 'Back' : _ref$backButtonScreen,
    children = _ref.children,
    className = _ref.className,
    developmentUrl = _ref.developmentUrl,
    displayCompactWidthInSideView = _ref.displayCompactWidthInSideView,
    _ref$hasBackButton = _ref.hasBackButton,
    hasBackButton = _ref$hasBackButton === void 0 ? false : _ref$hasBackButton,
    heading = _ref.heading,
    _ref$headingElement = _ref.headingElement,
    headingElement = _ref$headingElement === void 0 ? 'h2' : _ref$headingElement,
    id = _ref.id,
    initialSize = _ref.initialSize,
    isCoWorking = _ref.isCoWorking,
    isOpened = _ref.isOpened,
    isModalExpandable = _ref.isModalExpandable,
    largerTitleInBottomView = _ref.largerTitleInBottomView,
    offsetHeightInSideView = _ref.offsetHeightInSideView,
    backButtonCallback = _ref.backButtonCallback,
    onClose = _ref.onClose,
    onOpenAnimationEnd = _ref.onOpenAnimationEnd,
    showSideSheetOnViewportSM = _ref.showSideSheetOnViewportSM;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpened_internal = _useState2[0],
    setIsOpened_internal = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isResizingOnClick = _useState4[0],
    setIsResizingOnClick = _useState4[1];
  var _useState5 = useState(undefined),
    _useState6 = _slicedToArray(_useState5, 2),
    sideViewHeightOffsetAsCssCustomVariable = _useState6[0],
    setSideViewHeightOffsetAsCssCustomVariable = _useState6[1];
  var _useState7 = useState(),
    _useState8 = _slicedToArray(_useState7, 2),
    lastFocusedElement = _useState8[0],
    setLastFocusedElement = _useState8[1];
  var dialogRef = useRef();
  if (ref) {
    dialogRef = ref;
  }
  var headerRef = useRef();
  var backButtonRef = useRef();
  var contentWrapperRef = useRef();
  var visibleTabbableElements = useRef();
  if (isCoWorking) {
    initialSize = 'small'; // co-working ignores initialSize and always opens small
  } else {
    if (initialSize === undefined) {
      initialSize = 'large'; // modal defaults to opening as large
    }
  }
  useEffect(function () {
    /* is opened state is tracked internally, separate to the value passed in from parent.
    this allows us to delay calling parent onClose till our own closing transition finishes
    */
    setIsOpened_internal(isOpened);
  }, [isOpened]);
  var classes = 'able-Sheet';
  if (displayCompactWidthInSideView) {
    classes = classes.concat(' able-Sheet--compact-width');
  }
  if (largerTitleInBottomView) {
    classes = classes.concat(' able-Sheet--title-big-in-bottom-view');
  }
  if (showSideSheetOnViewportSM) {
    classes = classes.concat(' able-Sheet--small-screen-displays-on-side');
  }
  if (isResizingOnClick) {
    classes = classes.concat(' Able-Sheet--resize-click-transition');
  }
  classes = classnames(classes, className || undefined);
  var reactGeneratedId = useId();
  var sheetId = id ? id : reactGeneratedId;
  var HeadingElement = headingElement;
  var headingId = "".concat(sheetId, "__heading");
  var debouncedHandleResize = debounce(function () {
    if (dialogRef.current && dialogRef.current.clientHeight > window.innerHeight) {
      // page has been zoomed so that dialog is larger than window, make it full size
      dialogRef.current.style.setProperty('--able-sheet-height-for-animate-out', '0vh');
    }
  }, 10);
  var closeOnEscapeKey = function closeOnEscapeKey(event) {
    // close on escape key (needed for co-working, and replaces inconsistent implementation of dialog cancel between browsers - firefox works, chrome in modal doesn't)
    if (event.key === 'Escape') {
      setIsOpened_internal(false);
    }
  };
  var setVisibleTabbableElements = function setVisibleTabbableElements() {
    visibleTabbableElements.current = getVisibleTabbableElements(dialogRef.current);
  };
  var applyMoveFocusIntoSheet = function applyMoveFocusIntoSheet() {
    var header = headerRef.current;
    var grabberButton = header.querySelector('button:not(:last-of-type):not(.able-sheet__back-button)');
    var isGrabberButtonVisible = grabberButton !== null && grabberButton.offsetParent !== null;
    var isBackButtonPresent = backButtonRef.current !== undefined && backButtonRef.current !== null; // uninitialised, or removed

    var hasAnyElementBeenFocused = lastFocusedElement === undefined;
    var isHeaderFocused = lastFocusedElement === header;
    var isGrabberFocused = lastFocusedElement === grabberButton;
    var isLastFocusedElementRemovedFromDom = lastFocusedElement !== undefined && !document.contains(lastFocusedElement);
    var isSetDefaultFocus = hasAnyElementBeenFocused || isHeaderFocused || isGrabberFocused || isLastFocusedElementRemovedFromDom;
    var elementReceivingFocus;
    if (isSetDefaultFocus) {
      if (isGrabberButtonVisible) {
        // expandable sheet in bottom view, focus to grabber
        elementReceivingFocus = grabberButton;
      } else if (isBackButtonPresent) {
        elementReceivingFocus = backButtonRef.current;
      } else {
        elementReceivingFocus = header;
      }
    } else {
      elementReceivingFocus = lastFocusedElement;
    }
    elementReceivingFocus.focus();
    setLastFocusedElement(elementReceivingFocus);
  };
  var reIndexSheetModalKeyboardTrap = function reIndexSheetModalKeyboardTrap() {
    if (!isCoWorking) {
      setVisibleTabbableElements();
    }
  };
  useEffect(function () {
    if (isOpened_internal) {
      dialogRef.current.style.setProperty('--able-sheet-height-for-animate-out', sheetPresetHeights[initialSize]);
      dialogRef.current.classList.add('Able-sheet--open'); // display block required to allow opening and closing animations
      if (isCoWorking) {
        dialogRef.current.show();
      } else {
        dialogRef.current.showModal();
        document.body.style.overflow = 'hidden'; // prevent bg scroll
      }
      window.addEventListener('keydown', closeOnEscapeKey);
      window.addEventListener('resize', debouncedHandleResize);

      // custom events for consumer to manipulate an open sheet
      window.addEventListener('focusMovedIntoSheet', applyMoveFocusIntoSheet);
      window.addEventListener('reIndexSheetModalKeyboardTrap', reIndexSheetModalKeyboardTrap);
    } else {
      var _dialogRef$current;
      (_dialogRef$current = dialogRef.current) === null || _dialogRef$current === void 0 || _dialogRef$current.close();
      if (!isCoWorking) {
        document.body.style.overflow = 'initial'; // restore page scrolling
      }
      setLastFocusedElement(undefined);
    }
    return function () {
      window.removeEventListener('resize', debouncedHandleResize);
      window.removeEventListener('keydown', closeOnEscapeKey);
      window.removeEventListener('focusMovedIntoSheet', applyMoveFocusIntoSheet);
      window.removeEventListener('reIndexSheetModalKeyboardTrap', reIndexSheetModalKeyboardTrap);
    };
  }, [isOpened_internal]);
  var handleOnCancel = function handleOnCancel() {
    setIsOpened_internal(false);
  };
  var handleAnimationEnd = function handleAnimationEnd() {
    if (isOpened_internal) {
      setVisibleTabbableElements();
      applyMoveFocusIntoSheet();
      if (onOpenAnimationEnd) {
        onOpenAnimationEnd();
      } // call consumer callback after opening animation has ended
    } else {
      dialogRef.current.style.removeProperty('--able-sheet-height-for-animate-out');
      dialogRef.current.style.removeProperty('top');
      dialogRef.current.classList.remove('Able-sheet--open');
      onClose(); // call consumer onClose after transition has ended
    }
  };
  var handleTransitionEnd = function handleTransitionEnd() {
    setIsResizingOnClick(false);
  };
  var handleFocusIn = function handleFocusIn(event) {
    // For tracking last focused element, to retain user selection when changing views.
    // After initial default focus has been set, listen for 'focusin' event on dialog and update 'lastFocusedElement'.
    // Note this attaches to onFocus, as React handles both focus and focusin events with onFocus.
    if (lastFocusedElement) {
      setLastFocusedElement(event.target);
    }
  };
  var modalKeyboardTrap = function modalKeyboardTrap(event) {
    if (!isCoWorking) {
      focusNextVisibleTabbableElement(event, visibleTabbableElements.current);
    }
  };
  var grabberButtonComponent = isCoWorking || isModalExpandable ? /*#__PURE__*/_jsx(GrabberButton, {
    dialogRef: dialogRef,
    sheetId: sheetId,
    parentStateSetIsResizingOnClick: setIsResizingOnClick
  }) : null;
  var backButton = hasBackButton && backButtonCallback ? /*#__PURE__*/_jsx(IconButton, {
    ref: backButtonRef,
    icon: "ArrowLeft",
    developmentUrl: developmentUrl,
    screenReaderContent: backButtonScreenReaderContent,
    className: "able-sheet__back-button",
    useTouchTargetSize: 40,
    containerColour: "Transparent",
    events: {
      onClick: backButtonCallback
    }
  }) : null;
  useEffect(function () {
    var updatedSideViewHeightOffsetAsCssCustomVariable = undefined;
    if (offsetHeightInSideView) {
      if (isCoWorking && !isNaN(offsetHeightInSideView)) {
        updatedSideViewHeightOffsetAsCssCustomVariable = {
          '--able-sheet-side-view-height-offset': offsetHeightInSideView
        };
      } else {
        console.error('ABLE Sheet: offsetHeightInSideView can apply to Co-working variant only, and must be a number');
      }
    }
    setSideViewHeightOffsetAsCssCustomVariable(updatedSideViewHeightOffsetAsCssCustomVariable);
  }, [offsetHeightInSideView]);
  return /*#__PURE__*/_jsxs("dialog", {
    id: id,
    ref: dialogRef,
    "aria-labelledby": headingId,
    onCancel: handleOnCancel,
    className: classes,
    onAnimationEnd: handleAnimationEnd,
    onTransitionEnd: handleTransitionEnd,
    onKeyDown: modalKeyboardTrap,
    style: sideViewHeightOffsetAsCssCustomVariable,
    onFocus: handleFocusIn,
    children: [/*#__PURE__*/_jsxs("header", {
      ref: headerRef,
      "aria-labelledby": headingId,
      tabIndex: -1,
      children: [grabberButtonComponent, backButton, /*#__PURE__*/_jsx(HeadingElement, {
        id: headingId,
        children: heading
      }), /*#__PURE__*/_jsx(IconButton, {
        icon: "Close",
        developmentUrl: developmentUrl,
        screenReaderContent: "Close",
        containerColour: "Transparent",
        useTouchTargetSize: 40,
        events: {
          onClick: handleOnCancel
        }
      })]
    }), /*#__PURE__*/_jsx("div", {
      tabIndex: 0,
      role: "region",
      "aria-labelledby": headingId,
      ref: contentWrapperRef,
      children: children
    })]
  });
})));
/* harmony default export */ const Sheet_Sheet = ((/* unused pure expression or super */ null && (Sheet)));
;// ./src/Accordion/AccordionItem.tsx


function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }




/**
 * Accordions display a list of high-level options that can expand/contract to reveal more detailed information.
 * The outer Accordion is passed as children one or more AccordionItem.
 *
 * [View the Accordion pattern documentation on Confluence](https://confluence.tools.telstra.com/display/DCSYS/Accordion)
 *
 * @version 1.0.0
 */

function AccordionItem(props) {
  var id = props.id,
    developmentUrl = props.developmentUrl,
    _props$titleElement = props.titleElement,
    titleElement = _props$titleElement === void 0 ? 'h2' : _props$titleElement,
    label = props.label,
    icon = props.icon,
    events = props.events,
    onAbleAccordionItemPressed = props.onAbleAccordionItemPressed,
    valueText = props.valueText,
    children = props.children;
  var _useState = (0,external_react_namespaceObject.useState)(false),
    _useState2 = slicedToArray_default()(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1]; // whether accordion is expanded or collapsed
  var _useState3 = (0,external_react_namespaceObject.useState)(false),
    _useState4 = slicedToArray_default()(_useState3, 2),
    accordionIsTransitioning = _useState4[0],
    setAccordionIsTransitioning = _useState4[1]; // whether accordion is in transitional phase of opening or closing
  var _useState5 = (0,external_react_namespaceObject.useState)(''),
    _useState6 = slicedToArray_default()(_useState5, 2),
    heightStyle = _useState6[0],
    setHeightStyle = _useState6[1]; // content height: changes in transitional phase to allow animation to run, and to auto when expanded to allow resizing

  var accordionItemButtonRef = (0,external_react_namespaceObject.useRef)(null);
  var accordionItemContentOuterRef = (0,external_react_namespaceObject.useRef)(null);
  var accordionItemContentInnerRef = (0,external_react_namespaceObject.useRef)(null);
  var reactGeneratedId = (0,external_react_namespaceObject.useId)();
  var accordionItemId = id ? id : reactGeneratedId;
  var buttonId = "accordion-item-".concat(accordionItemId, "__button");
  var contentId = "accordion-item-".concat(accordionItemId, "__content");
  var heightStyles = {
    closed: '',
    open: 'auto'
  };
  var TitleElement = titleElement;
  var chevronRight = 'ChevronRight';
  var CustomIcon = function CustomIcon() {
    if (icon && !valueText) {
      return /*#__PURE__*/(0,jsx_runtime_.jsx)(Icon["default"], {
        icon: icon,
        developmentUrl: developmentUrl,
        size: "24"
      });
    }
    return null;
  };
  var _ref = events || {},
    onClick = _ref.onClick;
  var handleClick = function handleClick() {
    if (!accordionIsTransitioning) {
      setIsExpanded(function (isExpanded) {
        return !isExpanded;
      });
      setAccordionIsTransitioning(true);
      if (onClick && typeof onClick === 'function') {
        onClick();
      }
    }
  };
  (0,external_react_namespaceObject.useEffect)(function () {
    if (onAbleAccordionItemPressed && typeof onAbleAccordionItemPressed === 'function') {
      onAbleAccordionItemPressed({
        accordionItemId: accordionItemId,
        expanded: isExpanded
      });
    }
  }, [isExpanded]);
  (0,external_react_namespaceObject.useEffect)(function () {
    if (accordionIsTransitioning) {
      if (heightStyle === heightStyles.closed || heightStyle === heightStyles.open) {
        setHeightStyle("".concat(accordionItemContentInnerRef.current.offsetHeight, "px"));
        // Subsequently,
        // - expanding: transitionEnd event sets height to auto
        // - collapsing: useEffect applies transition and removes height
      }
    }
  }, [accordionIsTransitioning]);

  // collapsing - apply transition and remove height
  (0,external_react_namespaceObject.useEffect)(function () {
    if (!isExpanded && accordionIsTransitioning && heightStyle !== heightStyles.open && heightStyle !== heightStyles.closed) {
      if (accordionItemContentInnerRef.current && accordionItemContentInnerRef.current.offsetHeight > 0) {
        /* Superfluous property reference in condition forces browser repaint, applying transition
          Background: force repaint to get animation to reapply https://n12v.com/css-transition-to-from-auto/
          Repaint triggering : https://gist.github.com/paulirish/5d52fb081b3570c81e3a
         */
        setHeightStyle(heightStyles.closed);
      }
    }
  }, [heightStyle]);
  var transitionEndEvent = function transitionEndEvent(evt) {
    if (evt.propertyName === 'height') {
      if (heightStyle !== heightStyles.open && isExpanded) {
        setHeightStyle(heightStyles.open);
      }
      setAccordionIsTransitioning(false);

      // notify sheet component of content visibility change
      updateAbleSheet({
        moveFocusIntoSheet: false
      });
    }
  };
  var accordionItemExpandedClass = isExpanded ? 'accordion--expanded' : undefined;
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("div", {
    className: accordionItemExpandedClass,
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)(TitleElement, {
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("button", _objectSpread(_objectSpread({
        "aria-expanded": isExpanded,
        "aria-controls": contentId,
        id: buttonId,
        ref: accordionItemButtonRef
      }, events), {}, {
        onClick: handleClick,
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)(Icon["default"], {
          icon: chevronRight,
          developmentUrl: developmentUrl,
          size: "24"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("span", {
          children: label
        }), valueText && /*#__PURE__*/(0,jsx_runtime_.jsx)("span", {
          children: valueText
        }), CustomIcon()]
      }))
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("div", {
      id: contentId,
      role: "region",
      "aria-labelledby": buttonId,
      ref: accordionItemContentOuterRef,
      onTransitionEnd: transitionEndEvent,
      style: {
        height: heightStyle
      },
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("div", {
        ref: accordionItemContentInnerRef,
        children: children
      })
    })]
  });
}
/* harmony default export */ const Accordion_AccordionItem = (AccordionItem);
// EXTERNAL MODULE: ./src/Accordion/Accordion.scss
var src_Accordion_Accordion = __webpack_require__(7629);
;// ./src/Accordion/index.ts




/* harmony default export */ const src_Accordion = (Accordion_Accordion);
})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});